module.exports = __webpack_public_path__ + "static/img/round.cd748e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/round.png
// module id = tNQL
// module chunks = 1